export const integrationsBaseUrl = INTEGRATIONS_BASE_URL.replace(
	'{BUILD_VERSION}',
	BUILD_VERSION
);

export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
